// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:-webkit-autofill,
select:-webkit-autofill,
textarea:-webkit-autofill {
  animation-name: onautofillstart;
}

input:not(:-webkit-autofill),
select:not(:-webkit-autofill),
textarea:not(:-webkit-autofill) {
  animation-name: onautofillcancel;
}

@keyframes onautofillstart {
  from {
  }
}
@keyframes onautofillcancel {
  from {
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/autofill.css"],"names":[],"mappings":"AAAA;;;EAGE,+BAA+B;AACjC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE;EACA;AACF;AACA;EACE;EACA;AACF","sourcesContent":["input:-webkit-autofill,\nselect:-webkit-autofill,\ntextarea:-webkit-autofill {\n  animation-name: onautofillstart;\n}\n\ninput:not(:-webkit-autofill),\nselect:not(:-webkit-autofill),\ntextarea:not(:-webkit-autofill) {\n  animation-name: onautofillcancel;\n}\n\n@keyframes onautofillstart {\n  from {\n  }\n}\n@keyframes onautofillcancel {\n  from {\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
